<template>
  <div class="ui container">
    <generic-container
      :title="$t('users')"
      icon="users"
      :searchable="true"
      :show_refresh="true"
      @refresh="getData"
      :show_plus="true"
      :configurable="true"
      v-bind:configure_modal="configure_modal"
      v-on:add="add"
      v-on:filter="filter"
    >
      <table
        class="ui celled very compact selectable striped table"
        ref="table"
        style="width:100%"
      >
        <thead>
          <tr>
            <th>{{ $t("name") }}</th>
            <th>{{ $t("student card id") }}</th>
            <th>{{ $t("portal username") }}</th>
            <th>{{ $t("status") }}</th>
            <th>{{ $t("create date") }}</th>
            <!-- <th>{{ $t("options") }}</th> -->
          </tr>
        </thead>
        <tbody></tbody>
      </table>
    </generic-container>
    <template v-for="(mdl, index) in popup_modals">
      <component
        :is="mdl"
        :key="index"
        :portal_user_in="selected_portal_user"
        v-on:destroy="destroy"
        v-on:succedded="succedded"
      ></component>
    </template>
  </div>
</template>

<script>
import { clone, init_ajax_data_datables, enterprise_setup } from "@/utils";
import filters from "@/filters";
import GenericContainer from "@/components/GenericContainer";
import ConfigureModal from "@/modules/student_portal/configure_modal/Index";
import "datatables.net";
import "datatables.net-se";
import PortalUserModal from "./portal_user_modal/Index.vue";

// @ is an alias to /src
export default {
  name: "StudentPortalUsers",
  components: {
    "generic-container": GenericContainer,
  },
  filters: filters,
  data() {
    return {
      products: [],
      all_products: [],
      configure_modal: ConfigureModal,
      popup_modals: [],
      table: undefined,
      selected_portal_user: undefined,
    };
  },
  methods: {
    add() {
      this.popup_modals.push(PortalUserModal);
    },
    succedded(product) {
      let trgtIdx = this.products.findIndex(
        (n) => n.customer_id == product.product_id,
      );
      if (trgtIdx == -1) {
        this.products.push(product);
      } else {
        this.products.splice(trgtIdx, 1, product);
      }
      this.destroy();
    },
    destroy() {
      this.popup_modals = [];
      this.selected_portal_user = undefined;
    },
    filter(filter) {
      // console.log(filter);
      if (filter == "") this.products = clone(this.all_products);
      else
        this.products = this.all_products.filter((n) =>
          n.name.toUpperCase().includes(filter.toUpperCase()),
        );
    },
    select_user(user) {
      this.selected_portal_user = user;
      this.popup_modals.push(PortalUserModal);
      // this.$router.push({
      //   name: "StudentView",
      //   query: { i: user.std_student.uuid },
      // });
    },
    getData() {
      if (this.table) this.table.ajax.reload();
    },
  },
  mounted() {
    let vm = this;
    let ent_setup = enterprise_setup(vm);
    window
      .jQuery(vm.$refs.tabs)
      .find(".item")
      .tab();

    let onSelect = (data) => {
      vm.select_user(data);
    };

    let columns = [
      {
        data: function(row) {
          return row.std_student?.name;
        },
      },
      {
        data: function(row) {
          return row.std_student?.student_id_card;
        },
      },
      {
        data: function(row) {
          // console.log(row);
          return row.username;
        },
      },
      {
        data: function(row) {
          // console.log(row);
          return row.status_code;
        },
      },
      {
        data: function(row) {
          return filters.formatDate(
            row.create_date,
            ent_setup.detailed_date_format,
          );
        },
      },
    ];

    this.table = init_ajax_data_datables(
      vm,
      vm.$refs.table,
      window.jQuery.fn.api.settings.api["user portal users url"],
      columns,
      onSelect,
    );
  },
  watch: {},
};
</script>
